import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useTargetLanguagesContext } from 'src/context/targetLanguages';
import { getHref } from 'src/utils/getHref';
import { ROUTES } from 'src/constants/routes.const';
import { tryGetTargetMessages, getTargetMessages } from 'src/utils/getTargetMessages';
import { LanguagePairLink } from 'src/types/link';
import * as localesWithMessages from './messages';

export const usePhrasebooksLinks = (): LanguagePairLink[] => {
  const intl = useIntl();
  const targetLanguages = useTargetLanguagesContext();

  return useMemo(
    () =>
      targetLanguages
        .filter(
          ({ targetLanguageLocale }) =>
            !!tryGetTargetMessages(localesWithMessages, targetLanguageLocale),
        )
        .map(({ sourceLanguageLocale, targetLanguageLocale, targetLanguageImage }) => {
          const msgs = getTargetMessages(localesWithMessages, targetLanguageLocale);

          return {
            text: intl.formatMessage(msgs.phrasebook),
            href: getHref({
              pathname: ROUTES.phrasebook.allLearnables,
              query: {
                sourceLanguageLocale,
                targetLanguageLocale,
              },
            }),
            image: { externalSrc: targetLanguageImage },
          };
        })
        .sort((a, b) => a.href.localeCompare(b.href)),
    [targetLanguages, intl],
  );
};
